import {
  put,
  takeEvery,
  delay,
  take,
  call,
  race,
  select,
} from "redux-saga/effects";
import { actions, selectors } from "redux-store";
import { Action } from "redux";
import { ApiFailAction } from "redux-store/extra-actions/apis/api-builder";
import { AlertTypes } from "components/AppAlertBox";

function* closeFeedbackTask() {
  yield delay(5000);
  yield put(actions.closeFeedback());
}

export function* closeFeedbackSaga() {
  yield takeEvery(actions.setFeedback.type, function* () {
    yield race({
      task: call(closeFeedbackTask),
      cancel: take(actions.setFeedback.type),
    });
  });
}

export function* ajaxSuccessFeedbackSaga() {
  yield takeEvery(actions.postMerchants.success.type, function* () {
    yield put(
      actions.setFeedback({
        type: AlertTypes.success,
        message: "Nuova attività creata con successo!",
      }),
    );
  });

  yield takeEvery(
    actions.postMerchantsEventsByMerchantId.success.type,
    function* () {
      yield put(
        actions.setFeedback({
          type: AlertTypes.success,
          message: "Nuova promozione creato con successo!",
        }),
      );
    },
  );

  yield takeEvery(actions.postNotifications.success.type, function* () {
    yield put(
      actions.setFeedback({
        type: AlertTypes.success,
        message: "Notifica inviata con successo!",
      }),
    );
  });

  yield takeEvery(
    actions.patchMerchantsEventsByMerchantIdAndEventId.success.type,
    function* () {
      yield put(
        actions.setFeedback({
          type: AlertTypes.success,
          message: "Promozione aggiornata con successo!",
        }),
      );
    },
  );

  yield takeEvery(
    actions.getMerchantsSingleUseEventsByMerchantId.success.type,
    function* () {
      const singleUseEvent = yield select(selectors.getSingleUseEvent);
      if (singleUseEvent === null) {
        yield put(
          actions.setFeedback({
            type: AlertTypes.error,
            message: "Evento non trovato.",
          }),
        );
      } else if (singleUseEvent.hasBeenUsed) {
        yield put(
          actions.setFeedback({
            type: AlertTypes.warning,
            message:
              "Attenzione, questo codice promozione è già stato utilizzato.",
          }),
        );
      } else {
        yield put(
          actions.setFeedback({
            type: AlertTypes.success,
            message: "Codice promozione trovato e non ancora utilizzato!",
          }),
        );
      }
    },
  );

  yield takeEvery(
    actions.patchSingleUseEventsBySingleUseEventId.success.type,
    function* () {
      yield put(
        actions.setFeedback({
          type: AlertTypes.success,
          message: "Promozione utilizzata con successo!",
        }),
      );
    },
  );
}

export function* ajaxFailFeedbackSaga() {
  yield takeEvery(
    (action: Action) => /^apis\/(.*?)\/fail$/.test(action.type),
    function* (action: any) {
      const online = yield select(selectors.getNetworkState);

      if (!online) {
        yield put(
          actions.setFeedback({
            type: AlertTypes.warning,
            message: "Torna online per scaricare nuovi dati",
          }),
        );
      } else {
        switch (action.type) {
          default:
            yield put(
              actions.setFeedback({
                type: AlertTypes.error,
                message: action.payload.message,
              }),
            );
        }
      }
    },
  );
}

export function* awsErrorFeedbackSaga() {
  yield takeEvery(actions.cognitoSetAwsError, function* (action) {
    yield put(
      actions.setFeedback({
        type: AlertTypes.error,
        message: action.payload.message,
      }),
    );
  });
}
